<template>
  <div>
    <b-form-file
      :key="key"
      :disabled="Boolean(uploadInProgress)"
      :multiple="Boolean(multiple)"
      :accept="String(acceptedTypes)"
      v-model="selectedFiles"
      :state="validationState"
      placeholder="Choose a file or drop it here..."
      :file-name-formatter="formatNames"
      drop-placeholder="Drop file here..."
      @input="onSelectFile"
    />

    <b-list-group class="my-3 no-round">
      <transition-group name="fade" mode="out-in">
        <b-list-group-item
          v-for="item in items"
          :key="item.id"
          class="d-flex justify-content-between align-items-center no-round p-1"
        >
          <div class="border p-2">
            {{ item.name }}
          </div>

          <div>
            <b-badge
              :variant="item.progress == 100 ? 'success' : 'primary'"
              pill
              >{{ item.progress }}%
              <span class="spinner d-inline-block" v-if="item.progress != 100">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
            </b-badge>
            <span
              v-if="item.progress > 1"
              style="cursor: pointer"
              title="Delete"
              @click="deleteFile(item.id)"
              class="text-danger"
            >
              <i class="lni lni-cross-circle"></i>
            </span>
          </div>
        </b-list-group-item>
      </transition-group>
    </b-list-group>
  </div>
</template>

<script>
import fileRepo from "@/api/repos/fileRepo";
import axios from "axios";

export default {
  props: {
    multiple: {
      default: false,
      type: Boolean,
    },

    acceptedTypes: {
      default: "*",
      type: String,
    },
    validationState: {
      default: null,
      type: Boolean,
    },
  },
  computed: {
    uploadedFiles() {
      if (this.fileIds.length > 0) {
        return this.fileIds.toString();
      }
      return null;
    },
    uploadStatus() {
      return false;
    },
  },
  data() {
    return {
      key: 1,
      fileUploadUrl: "api/files",
      selectedFiles: null,
      items: [],
      uploadInProgress: false,
      fileIds: [],
    };
  },
  methods: {
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `multiple files selected`;
      }
    },
    onSelectFile() {
      if (this.selectedFiles !== null) {
        this.$emit("files-uploaded-started");
        let fileList = this.selectedFiles;
        // this.selectedFiles = null
        if (!this.multiple) {
          this.items = [];
          this.fileIds = [];
        }

        if (this.multiple) {
          fileList.forEach((file) => {
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            const reader = new FileReader();
            var rand = Math.random().toString(36).substring(7);
            reader.onload = (e) => {
              this.items.push({
                id: rand,
                name: file.name,
                file: e.target.result,
                progress: 0,
                cancelToken: source.token,
                source: source,
              });
              if (!this.fileCrop) this.uploadFile(file, rand, source.token);
            };
            reader.readAsDataURL(file);
          });
        } else {
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();

          const reader = new FileReader();
          reader.onload = (e) => {
            this.items.push({
              id: 0,
              name: fileList.name,
              file: e.target.result,
              progress: 0,
              cancelToken: source.token,
              source: source,
            });
            if (!this.fileCrop) this.uploadFile(fileList, 0, source.token);
          };
          reader.readAsDataURL(fileList);
        }
      }
    },

    onProgress(percent, id) {
      this.items = this.items.map((x) => {
        if (x.id === id) {
          return { ...x, progress: percent };
        }
        return x;
      });
    },

    async uploadFile(file, id, token) {
      try {
        let { data } = await fileRepo.upload(
          this.fileUploadUrl,
          file,
          this.onProgress,
          id,
          token
        );
        if (this.multiple) {
          this.fileIds.push(data.id);
        } else {
          this.fileIds[0] = data.id;
        }
        // set new returned id and mark as 100%
        this.items = this.items.map((x) => {
          if (x.id === id) {
            return { ...x, id: data.id, progress: 100 };
          }
          return x;
        });

        // check all uploaded and notify
        if (this.items.length === this.fileIds.length) {
          this.$emit("files-uploaded", this.uploadedFiles);
        }
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 3000,
          variant: "danger",
        });

        this.items = [];
        this.key = this.key + 1;
      }
    },

    deleteFile(id) {
      let source;
      this.items.forEach((x) => {
        if (x.id === id) {
          source = x.source;
        }
      });

      this.fileIds = this.fileIds.filter((x) => x !== id);
      this.items = this.items.filter((x) => x.id !== id);

      fileRepo.cancel(source);

      if (this.items.length === this.fileIds.length) {
        this.$emit("files-uploaded", this.uploadedFiles);
      }
    },
  },
};
</script>


